module.exports = __webpack_public_path__ + "img/A58A0050_min.dfd08d24.jpg";